import React from 'react';
import styles from './HowItWorksSection.module.css';

const HowItWorksSection = () => {
  const steps = [
    { id: 1, title: 'Regístrate', description: 'Crea tu cuenta en minutos.', icon: '📝' },
    { id: 2, title: 'Elige tu juego', description: 'Participa en los mejores sorteos.', icon: '🎲' },
    { id: 3, title: 'Gana', description: 'Recibe tus ganancias de forma segura.', icon: '💰' },
  ];

  return (
    <section className={styles.howItWorks}>
      <h2 className={styles.title}>Empieza en solo 3 pasos</h2>
      <p className={styles.subtitle}>Participar nunca fue tan fácil. ¡Sigue estos pasos y comienza a ganar hoy!</p>
      <div className={styles.steps}>
        {steps.map((step) => (
          <div key={step.id} className={styles.step}>
            <div className={styles.iconWrapper}>
              <span className={styles.icon}>{step.icon}</span>
            </div>
            <h3 className={styles.stepTitle}>{step.title}</h3>
            <p className={styles.stepDescription}>{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorksSection;
